import { useEffect } from 'react'
import { Layout, Typography, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../utils/redux/store'
import {
  attemptGetPlaylistsList,
  attemptGetMoodsList,
  attemptGetStylesList,
  attemptGetDaytimesList,
  attemptGetBusinessesList,
  PlaylistOrderBy,
} from '../../utils/redux/playlistSlice'
import { attemptGetFavs } from '../../utils/redux/favsSlice'
import { OrderDirection } from '../../utils/dto'
import PlaylistSection from '../../components/PlaylistSection'
import './Home.scss'

const { Content } = Layout
const { Title } = Typography

export default function Home() {
  const { t } = useTranslation('home')
  const dispatch = useAppDispatch()
  const { playlistsBrief, moods, styles, daytimes, businesses } = useAppSelector(
    (state) => state.playlist,
  )

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        dispatch(
          attemptGetPlaylistsList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(
          attemptGetMoodsList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(
          attemptGetStylesList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(
          attemptGetDaytimesList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(
          attemptGetBusinessesList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(attemptGetFavs()),
      ])
    }
    fetchData()
  }, [dispatch])

  if (!playlistsBrief && !moods && !styles && !daytimes && !businesses) {
    return (
      <div className="home-loading">
        <Spin size="large" />
      </div>
    )
  }

  return (
    <Content className="home-content">
      <div className="home-container">
        <Title level={2} className="home-title">
          {t('welcomeMessage')}
        </Title>

        {playlistsBrief && playlistsBrief.length > 0 && (
          <PlaylistSection title={t('playlists')} items={playlistsBrief} type="playlist" />
        )}

        {moods && moods.length > 0 && (
          <PlaylistSection title={t('moods')} items={moods} type="mood" />
        )}

        {styles && styles.length > 0 && (
          <PlaylistSection title={t('styles')} items={styles} type="style" />
        )}

        {daytimes && daytimes.length > 0 && (
          <PlaylistSection title={t('daytimes')} items={daytimes} type="daytime" />
        )}

        {businesses && businesses.length > 0 && (
          <PlaylistSection title={t('businesses')} items={businesses} type="business" />
        )}
      </div>
    </Content>
  )
}
